import React from 'react';
import Select, { components } from 'react-select';
import BsArrowDown from '@meronex/icons/bs/BsArrowDown';
import { getConfig } from '../../../utils/config';

const Option = (props) => {
    // console.log(props)
    return (
        <div>
            <components.Option {...props}>
                <input
                    type="checkbox"
                    checked={props.isSelected}
                    onChange={() => null}
                />{' '}
                <label>{props.label}</label>
            </components.Option>
        </div>
    );
};

const MultiValueRemove = (props) => {
    return null;
};

const MultiValueLabel = (props) => {
    console.log(props);
    return (
        <components.MultiValueLabel {...props}>
            <div>
                {props.children}
                {props.selectProps?.value[props.selectProps?.value.length - 1]
                    ?.label == props.children
                    ? ''
                    : ','}
            </div>
        </components.MultiValueLabel>
    );
};
const DropdownIndicator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <BsArrowDown />
        </components.DropdownIndicator>
    );
};

const IndicatorSeparator = (props) => {
    return (
        <components.DropdownIndicator {...props}>
            <BsArrowDown />
        </components.DropdownIndicator>
    );
};

function CustomSelect({
    onChangeCallback,
    placeholder,
    className,
    options,
    selectedValues
}) {
    const config = getConfig();
    return (
        <div className={className}>
            <Select
                closeMenuOnSelect={false}
                isMulti
                components={{
                    Option,
                    MultiValueRemove,
                    MultiValueLabel,
                    IndicatorSeparator: () => null,
                    DropdownIndicator
                }}
                selectionType="text"
                options={options}
                hideSelectedOptions={false}
                backspaceRemovesValue={false}
                onChange={(e) => onChangeCallback(e)}
                placeholder={placeholder}
                isClearable={false}
                theme={
                    config?.darkMode
                        ? (theme) => ({
                              ...theme,
                              // borderRadius: 0,
                              colors: {
                                  ...theme.colors,
                                  /*
                                   * control/backgroundColor
                                   * menu/backgroundColor
                                   * option/color(selected)
                                   */
                                  // neutral0: "black",
                                  // neutral10: "grey",
                                  neutral50: '#ccc', // pacleholder color
                                  neutral80: 'white', //input color
                                  primary25: '#ccc', //option bg color focued
                                  primary: 'black', //option bg color selected
                                  primary50: 'white' // option bg color active(enavled or available)
                              }
                          })
                        : undefined
                }
                styles={{
                    ...(config?.darkMode && {
                        singleValue: (base) => ({ ...base, color: 'white' }),
                        menuList: (base) => ({
                            ...base,
                            backgroundColor: 'black',
                            color: 'white'
                        }),
                        option: (base) => ({ ...base, color: 'white' })
                    }),
                    multiValueLabel: (base) => ({
                        ...base,
                        backgroundColor: config?.darkMode ? 'black' : '#ffffff',
                        color: config?.darkMode ? '#ffffff' : 'black'
                    }),
                    placeholder: (base) => ({
                        ...base,
                        fontWeight: 500,
                        color: config?.darkMode ? 'white' : 'black'
                    }),
                    valueContainer: (base) => ({
                        ...base,
                        ...(config?.darkMode && { color: 'white' }),
                        padding: '11px 8px'
                    }),
                    control: (base) => ({
                        ...base,
                        borderColor: '#DDDDDD',
                        borderRadius: '0.5rem',
                        ...(config?.darkMode && { background: '#121212' })
                    })
                }}
                value={selectedValues}
                // {...otherProps}
            />
        </div>
    );
}

export default CustomSelect;
